import { css } from "@emotion/css"

const OneClickDivider = ({ margin = 10 }: { margin?: number }) => {
  return (
    <div
      className={styles.divider}
      style={{
        marginTop: margin,
        marginBottom: margin,
      }}
    />
  )
}

export default OneClickDivider

const styles = {
  divider: css`
    border-top: 1px solid #cacaca;
  `,
}
